module.exports = __webpack_public_path__ + "img/phoneIconBlack.2ebf0c5.svg";